import { useFieldArray, Control } from "react-hook-form";
import { FormValues } from "./EntrepotDetails/EntrepotForm/hooks/useEntrepotFormLogic";
import IsManageableCheckbox from "./isManageableCheckbox";

type Props = {
  control: Control<FormValues>;
};

function ManageableCompanies({ control }: Props) {
  const { fields } = useFieldArray({
    control,
    name: "companies",
  });

  return (
    <>
      {fields.map((company, index: number) => (
        <IsManageableCheckbox
          key={company.id}
          companyId={company._id}
          formControl={control}
          formFieldName={`companies.${index}.isManageable`}
          style={{ width: "100%" }}
        />
      ))}
    </>
  );
}

export default ManageableCompanies;
